export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11795.58b74d6d.jpg";